import { useState, useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { HeroSection } from "@/components/landing/HeroSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { HowToOrderSection } from "@/components/landing/HowToOrderSection";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { GaransiSection } from "@/components/landing/GaransiSection";
import { AnnouncementPopup } from "@/components/AnnouncementPopup";
import { fetchActiveAnnouncement, Announcement } from "@/lib/api";

const Index = () => {
  const [announcement, setAnnouncement] = useState<Announcement | null>(null);

  useEffect(() => {
    async function loadAnnouncement() {
      const data = await fetchActiveAnnouncement();
      setAnnouncement(data);
    }
    loadAnnouncement();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <FeaturesSection />
        <HowToOrderSection />
        <TestimonialsSection />
        <FAQSection />
        <GaransiSection />
      </main>
      <Footer />
      <AnnouncementPopup announcement={announcement} />
    </div>
  );
};

export default Index;
